// Chat settings (backend spec: backendhip/app/Chat/CLAUDE.md).
//
// Real time uses Laravel Reverb through laravel-echo. Set these at build time
// (.env / .env.production); without VUE_APP_REVERB_KEY the chat still works and
// just polls for new messages.
//   VUE_APP_REVERB_KEY=<REVERB_APP_KEY of the API>
//   VUE_APP_REVERB_HOST=claimify-api.hayokmedicare.ng
//   VUE_APP_REVERB_PORT=443
//   VUE_APP_REVERB_SCHEME=https

export const reverb = {
  key: process.env.VUE_APP_REVERB_KEY || "",
  host: process.env.VUE_APP_REVERB_HOST || "claimify-api.hayokmedicare.ng",
  port: Number(process.env.VUE_APP_REVERB_PORT || 443),
  scheme: process.env.VUE_APP_REVERB_SCHEME || "https",
};

// Account types that can use chat. Enrollees and vendors use the mobile app.
export const CHAT_USER_TYPES = ["shis", "employee", "provider", "provider_employee", "tpa", "tpa_employee"];

export const POLL_UNREAD_MS = 60 * 1000;
// refreshUnread() calls closer together than this reuse the last count.
export const UNREAD_MIN_INTERVAL_MS = 15 * 1000;
export const POLL_THREAD_MS = 20 * 1000;
export const TOAST_MS = 8000;
export const MAX_TOASTS = 3;

// Same token format as the API: [[claim:123]]
export const TAG_TOKEN = /\[\[([a-z_]+):(\d+)\]\]/g;

export function storedUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch (e) {
    return null;
  }
}

export function chatEnabledFor(user) {
  return !!user && !!localStorage.getItem("jwt") && CHAT_USER_TYPES.includes(user.type);
}
